import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { PermittingHttpService } from '@core/services/http';
import { useTabPrefetch } from '@core/utils/hooks';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { ContactsPlace } from '@models/enums';
import { Contacts } from '@shared/components';
import { PermittingActions } from '@store/actions';
import { PermittingSelectors, UserSelectors } from '@store/selectors';

export const PermittingContacts: FC = () => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();
  const { contactsAccess } = useSelector(
    UserSelectors.getPermittingBrowsePermissions,
  );

  const isLoading = useSelector(
    PermittingSelectors.getTabLoadingState('contacts'),
  );
  const isDataLoaded = useSelector(
    PermittingSelectors.getTabLoadedState('contacts'),
  );
  const { contacts } = useSelector(PermittingSelectors.getContactsTabData);

  useTabPrefetch('contacts', projectBundleID);

  const fetchData = async () => {
    if (!isDataLoaded) {
      dispatch(
        PermittingActions.setTabLoading.done({
          tabName: 'contacts',
          isLoading: true,
        }),
      );

      await HttpService.getHttpRequests(
        PermittingHttpService,
      ).getPermittingContactsData(projectBundleID);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, isDataLoaded]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-permitting-contacts loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="prov-permitting-contacts">
      <Contacts
        place={ContactsPlace.Permitting}
        data={contacts}
        editable={!!contactsAccess}
        hoverable={false}
      />
    </div>
  );
};
